export default __webpack_public_path__ + "static/LinkapparelExport-1a989298393065675816594f9bbd31ef.jpg";